export default "__VITE_ASSET__DNIm$vXK__"